export const CHAT_ATTEMPT = 'CHAT_ATTEMPT';
export const CHAT_SUCCESS = 'CHAT_SUCCESS';
export const CHAT_FAILED = 'CHAT_FAILED';
export const LOGOUT = "LOGOUT";